import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';

import { AppComponent } from './app.component';
import { MapComponent } from './component/map/map.component';
import { MenuComponent } from './component/menu/menu.component';
import { DownloadPopupComponent } from './component/popup/download-popup/download-popup.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AircraftPopupComponent } from './component/popup/aircraft-popup/aircraft-popup.component';
import { MatTabsModule } from '@angular/material/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { GroupsPopupComponent } from './component/popup/groups-popup/groups-popup.component';
import { MatListModule } from '@angular/material/list';
import { MessagesPopupComponent } from './component/popup/messages-popup/messages-popup.component';
import { MatSelectModule } from '@angular/material/select';
import { AkitaNgDevtools } from '@datorama/akita-ngdevtools';
import { environment } from '../environments/environment';
import { MapListComponent } from './component/list/map/map-list.component';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LoginPopupComponent } from './component/popup/login-popup/login-popup.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TokenInterceptor } from './interceptor/token-interceptor';
import { VehiclesComponent } from './component/list/vehicles/vehicles.component';
import { AntennasComponent } from './component/list/antennas/antennas.component';
import { FollowingComponent } from './component/list/following/following.component';
import { VehiclePopupComponent } from './component/popup/vehicle-popup/vehicle-popup.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    AppComponent,
    MapComponent,
    MenuComponent,
    DownloadPopupComponent,
    AircraftPopupComponent,
    GroupsPopupComponent,
    MessagesPopupComponent,
    MapListComponent,
    LoginPopupComponent,
    VehiclesComponent,
    AntennasComponent,
    FollowingComponent,
    VehiclePopupComponent,
  ],
  imports: [
    BrowserModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatCardModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatListModule,
    MatSelectModule,
    MatSnackBarModule,
    environment.production ? [] : AkitaNgDevtools.forRoot(),
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatRadioModule,
    MatTooltipModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
